export default "__VITE_ASSET__49b8c0d2__"